import { useAbility } from "@casl/react";

import { ActionsForRole, AvailableSections } from "@/api/admin/roleManagment";
import type { AdminSections } from "@/api/admin/teamRoles";

import { AbilityContext } from "./AbilityProvider";

export const usePermission = (
  subject: AdminSections | AvailableSections,
  {
    action = ActionsForRole.READ,
    isUpdate = false,
  }: { action?: ActionsForRole; isUpdate?: boolean } = {}
) => {
  const ability = useAbility(AbilityContext);

  const finalAction = isUpdate ? ActionsForRole.UPDATE : action;

  return ability.can(finalAction, subject);
};
